import YieldrFull from 'marketing-website/components/icons/YieldrFull';
import heroImage from 'marketing-website/media/images/pages/case-studies/yieldr/cover@2x.jpg';
import statsImage from 'marketing-website/media/images/pages/case-studies/yieldr/stats@2x.jpg';
import image01a from 'marketing-website/media/images/pages/case-studies/yieldr/image-01-a@2x.jpg';
import image01b from 'marketing-website/media/images/pages/case-studies/yieldr/image-01-b@2x.jpg';
import image02a from 'marketing-website/media/images/pages/case-studies/yieldr/image-02-a@2x.jpg';
import image02b from 'marketing-website/media/images/pages/case-studies/yieldr/image-02-b@2x.jpg';
import image03a from 'marketing-website/media/images/pages/case-studies/yieldr/image-03-a@2x.jpg';
import image03b from 'marketing-website/media/images/pages/case-studies/yieldr/image-03-b@2x.jpg';
import image05 from 'marketing-website/media/images/pages/case-studies/yieldr/image-05@2x.jpg';
import image00 from 'marketing-website/media/images/pages/case-studies/yieldr/image-00@2x.jpg';
import singleImage from 'marketing-website/media/images/pages/case-studies/yieldr/image-04@2x.jpg';
import imageQuote from 'marketing-website/media/images/pages/case-studies/yieldr/quote@2x.jpg';

const yieldrAssets = {
  heroImage: {
    alt: '',
    maxWidth: 504,
    src: heroImage,
  },
  heroLogo: YieldrFull,
  statsImage: {
    alt: '',
    maxWidth: 1290,
    src: statsImage,
  },
  stats: [
    {
      id: 0,
      stat: '30%',
      title: 'Productivity increase',
      copy:
        'With Marvel’s Handoff tool, design and engineering worked together seamlessly',
    },
    {
      id: 1,
      stat: '4x',
      title: 'Designs shipped',
      copy:
        'Marvel prototypes improved comms and reduced stakeholder back and forth',
    },
    {
      id: 2,
      stat: '200%',
      title: 'Time reduction',
      copy: 'With Marvel, decision making timeframes were faster and smoother',
    },
  ],
  singleImages: {
    first: {
      src: image00,
      maxWidth: 1141,
      alt: '',
    },
    second: {
      src: image05,
      maxWidth: 1141,
      alt: '',
    },
  },
  doubleImages: {
    first: [
      {
        src: image01a,
        maxWidth: 550,
        alt: '',
      },
      {
        src: image01b,
        maxWidth: 494,
        alt: '',
      },
    ],
    second: [
      {
        src: image02a,
        maxWidth: 556,
        alt: '',
      },
      {
        src: image02b,
        maxWidth: 556,
        alt: '',
      },
    ],
    third: [
      {
        src: imageQuote,
        maxWidth: 556,
        alt: '',
      },
      {
        maxWidth: 490,
        copy:
          '“It saves time in figuring out which prototype connects to which project. I don’t have to go back through Slack or email to find specs for a prototype or if it’s the latest one.”',
      },
    ],
    fourth: [
      {
        src: image03a,
        maxWidth: 536,
        alt: '',
      },
      {
        src: image03b,
        maxWidth: 550,
        alt: '',
      },
    ],
    singleImages: {
      first: {
        src: singleImage,
        maxWidth: 1141,
        alt: '',
      },
    },
  },
};

export default yieldrAssets;



// WEBPACK FOOTER //
// ./src/configs/caseStudies/yieldr.js